import { useContext } from 'react';

import { AuthenticationContext } from '../contexts/auth';
import { AuthContextProps } from '../contexts/auth/types';

export function useAuth(): AuthContextProps {
    return useContext(AuthenticationContext);
}
